<div [ngClass]="{ 'emma-timerange': true, disabled: disabled }">
    <div class="input-group">
        <emma-select
            [items]="units"
            [(ngModel)]="_selectedUnit"
            (ngModelChange)="onUnitChange($event)"
            [searchable]="false"
            [disabled]="disabled || units.length === 1"
            [color]="color"
            ($blur)="onBlur()"
        ></emma-select>
        <div class="input-group-text input-group-text-transparent input-group-slider-sibling">
            <span *ngIf="_selectedUnit !== 'none'" >{{ sliderValue | i18nPlural: unitsMapping[unitRef] }}</span>
        </div>
        <div class="input-group-slider">
            <ngx-slider
                class="emma-ngx-slider-brand"
                *ngIf="_selectedUnit !== 'none'"
                [ngModel]="sliderValue"
                (valueChange)="onValueChange($event)"
                (userChangeEnd)="onBlur()"
                [options]="sliderOptions"
            ></ngx-slider>
        </div>
    </div>
</div>
